export const RoutesNames = {
  HOME: '/',
  CHARACTERS: '/characters',
  COMICS: '/comics',
  STORIES: '/stories',
  BOOKMARKS: '/bookmarks',
} as const;

export type RoutesNamesKeys = (typeof RoutesNames)[keyof typeof RoutesNames];
